import React, { Fragment } from 'react'

export const Detail = ({response}) => {
    return (
        <div className="jl_single_style2">
            {
                (response != null) ?
                <Fragment>
                    <div className="single_post_entry_content single_bellow_left_align jl_top_single_title jl_top_title_feature">
                        <span className="meta-category-small single_meta_category">
                            <a className="post-category-color-text" style={{background: '#eba845'}} href="#">{response.nama_kategori_aduan}</a>
                        </span>
                        <h1 className="single_post_title_main">{response.judul_aduan}</h1>
                        <p className="post_subtitle_text">{response.sub_judul_artikel}</p>
                        <span className="jl_post_meta">
                            <span className="jl_author_img_w">
                                <i className="jli-user" />{response.dibuat_oleh}
                            </span>
                            <span className="post-date">
                                <i className="jli-pen" />{response.created_at}
                            </span>
                        </span>
                    </div>
                    <div className="jl_slide_wrap_s jl_clear_at">
                        <div className="jl_ar_top jl_clear_at">
                            <div className="jl-w-slider jl_full_feature_w">
                                <div className="jl-eb-slider jelly_loading_pro slick-initialized">
                                    <img src={process.env.REACT_APP_SERVER_IMAGE_URL + response.file_aduan} className="image-detail-size" alt="" />
                                    <div className="background_over_image" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="post_content_w">
                        <p>{response.konten_aduan}</p>
                    </div>
                </Fragment> : 'Loading ...'
            }
        </div>
    )
};